import Tippy from '@tippyjs/react';

import { cn } from 'lib/helpers/utility';

import Icon from 'components/shared/Icon/Icon';
import Checkbox from 'components/shared/Checkbox/Checkbox';
import Typography from 'components/shared/Typography/Typography';

const DocumentItem = ({ id, name, icon, checked, onSelect, onPreview }) => (
  <div
    className={cn(
      'flex h-fit min-h-16 cursor-pointer items-center gap-3 rounded-xl border border-solid py-3 pl-4 pr-5 shadow-[0px_4px_12px_rgba(65,70,81,0.08)]',
      'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-500',
      checked
        ? 'border-primary-500 bg-primary-25 hover:bg-primary-50'
        : 'border-neutral-300 bg-white hover:bg-neutral-75'
    )}
    onClick={() => onSelect(id)}>
    <div
      className={cn(
        'flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-solid border-neutral-300',
        checked ? 'bg-white' : 'bg-neutral-200'
      )}>
      <Icon icon={icon} size={24} color={checked ? 'primary' : 'neutral'} />
    </div>
    <Typography
      variant="p"
      size="small"
      weight="medium"
      parentClassName="min-w-0 flex-1"
      className="block">
      {name}
    </Typography>
    <Tippy content="Preview" className="tippy-dark" placement="top">
      <button
        type="button"
        aria-label={`Preview ${name}`}
        className="flex h-6 w-6 shrink-0 cursor-pointer items-center justify-center rounded border-0 bg-transparent p-0 hover:bg-neutral-100"
        onClick={(event) => {
          event.stopPropagation();
          onPreview(id);
        }}>
        <Icon icon="document-preview-mono" size={16} className="shrink-0" />
      </button>
    </Tippy>
    <div
      role="checkbox"
      aria-checked={checked}
      aria-label={name}
      tabIndex={0}
      className="flex shrink-0 items-center focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-500"
      onClick={(event) => {
        event.stopPropagation();
        onSelect(id);
      }}
      onKeyDown={(event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        onSelect(id);
      }}>
      <Checkbox
        isChecked={checked}
        tabIndex={-1}
        aria-hidden="true"
        className="pointer-events-none"
      />
    </div>
  </div>
);

export default DocumentItem;
